/* eslint-disable react/require-default-props */
/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import s from './Pdf.scss';

class Pdf extends React.Component {
  render() {
    const { msid, totalCnt } = this.props;
    const slides = [];
    for (let i = 0; i < totalCnt; i += 1) {
      slides.push(
        `https://static.toiimg.com/photo/msid-${msid}/${msid}.jpg?pageno=${i +
          1}`,
      );
    }
    return (
      <div
        data-wrapper="pdf"
        data-wap={this.props.isWapView}
        className={this.props.classes}
      >
        <div className={`${s.mediumscrollcontent}`}>
          {slides.map(value => (
            <div className={s.slideimgcontainer}>
              <div className={s.sliderimgwrapper}>
                <img alt={`pdf page number ${value}`} src={value} />
              </div>
            </div>
          ))}
        </div>
        {/* FullScreen Button */}
        <i />
      </div>
    );
  }
}

Pdf.propTypes = {
  msid: PropTypes.string.isRequired,
  totalCnt: PropTypes.number.isRequired,
  classes: PropTypes.string,
  isWapView: PropTypes.bool,
};

Pdf.defaultProps = {
  isWapView: false,
  class: '',
};

export default Pdf;
